import {
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Typography,
} from '@ace-clublabs/shared-component-library';

export interface RemoveWarningModalContentProps {
  title: string;
  warningContent?: string;
  confirmRemove: () => void;
}

export interface RemoveWarningModalProps extends RemoveWarningModalContentProps {
  showModal: boolean;
  closeModal: () => void;
  clickCancelAction?: () => void;
}

export const RemoveWarningModal: (props: RemoveWarningModalProps) => JSX.Element = ({
  title,
  warningContent,
  showModal,
  closeModal,
  confirmRemove,
  clickCancelAction,
}) => {
  return (
    <Modal
      className="confirm-remove-item-modal"
      open={showModal}
      size="small"
      maxWidth="sm"
      aria-labelledby="remove-item"
      aria-describedby="remove-item"
    >
      <ModalTitle id="remove-modal-title" className={'qm-mask'} sx={{ paddingRight: '2.5rem', marginBottom: '0' }}>
        {title}
        <ModalCloseIconButton
          aria-label="Close"
          onClick={() => {
            closeModal();
          }}
        />
      </ModalTitle>
      {warningContent && (
        <ModalContent id="modal-warning-content" sx={{ marginTop: '1rem' }}>
          <Typography variant="b1Regular" className={'qm-mask'}>
            {warningContent}
          </Typography>
        </ModalContent>
      )}

      <ModalActions
        actionLayout={{
          xs: 'shared',
          sm: 'shared',
          md: 'shared',
          lg: 'shared',
          xl: 'shared',
        }}
      >
        <ModalActionButton
          onClick={() => {
            clickCancelAction?.();
            closeModal();
          }}
          variant="outlined"
          label="Cancel"
        />
        <ModalActionButton
          onClick={() => {
            confirmRemove();
            closeModal();
          }}
          id="confirmRemovingItem"
          label="Confirm"
        />
      </ModalActions>
    </Modal>
  );
};
